































import { Component, Vue, Prop } from 'vue-property-decorator';
import RatingSelectAdvanced from '@/components/RatingSelectAdvanced/index.vue';
import TextAreaElement from '@/components/widgets/TextAreaElement.vue';
import { TextareaFieldProps } from '@/models/widgets/props/textarea-field';
import { EventBus } from '@/event-bus';
import { SurveyRatingElementOptions } from '@/models/survey-elements/rating-options';
import { SurveyRating5StarsElement } from '@/models/survey-elements/rating-5-stars-element';
import { WIDGET_EVENTS } from '@/const/widget-events';
import { ANALYTICS_EVENTS } from '@/const/analytics-events';
@Component({
  name: 'rating-5-star-widget',
  components: {
    RatingSelectAdvanced,
    TextAreaElement,
    FieldValidationError: () => import('@/components/FieldValidationError.vue'),
  },
})
export default class Rating5StarWidget extends Vue {
  @Prop({ type: Array, required: true })
  additionalTextAreaElements!: TextareaFieldProps[];
  @Prop({ type: String }) externalApiIdentifier!: string | null;
  @Prop({ type: Object }) value!: SurveyRatingElementOptions;
  @Prop({ type: Object }) field?: SurveyRating5StarsElement;
  @Prop({ type: String }) title?: string;
  @Prop({ type: Array, required: true }) options!: SurveyRatingElementOptions[];
  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  private localValue = this.value;
  private localNestedValue = '';

  private sendMixpanelRatingEvent() {
    this.$mixpanel(ANALYTICS_EVENTS.QUESTION_ANSWERED, {
      question_id: this.field?.id,
      question_type: 'rating',
      rating: this.localValue.rating,
      answer: [
        this.localValue.rating.toString(),
        ...(this.localNestedValue ? [this.localNestedValue] : []),
      ],
    });
  }

  private onChange(value: SurveyRatingElementOptions) {
    this.localValue = value;
    this.sendMixpanelRatingEvent();

    EventBus.$emit(WIDGET_EVENTS.CHANGE, { field: this.field, value });
  }

  private onNestedFieldChange(question: number, value: string) {
    this.localNestedValue = value;

    EventBus.$emit(WIDGET_EVENTS.NESTED_FIELD_CHANGE, {
      field: this.field,
      value,
      question,
    });
  }
}
